import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import ModernPageShell from "components/ModernPageShell";

export default function AboutUs() {
  const { t } = useTranslation();
  const settings = useSelector(state => state.settingsdata.settings);
  const customAbout = settings && settings.aboutUsContent;

  return (
    <ModernPageShell title={t('about_us')}>
      {customAbout ? (
        <p style={{ whiteSpace: 'pre-line' }}>{customAbout}</p>
      ) : (
        <>
          <p>{t('about_us_content2')}</p>
          <p>{t('about_us_content1')}</p>
        </>
      )}
    </ModernPageShell>
  );
}
